export default "__VITE_ASSET__DaNHE0DZ__"